import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem('zunoid_access');
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        if (!refreshing) {
          const rt = localStorage.getItem('zunoid_refresh');
          if (!rt) throw new Error('no refresh');
          refreshing = axios.post(`${API_BASE}/auth/refresh`, { refresh_token: rt });
        }
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem('zunoid_access', data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem('zunoid_access');
        localStorage.removeItem('zunoid_refresh');
        if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
          window.location.href = '/login';
        }
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  },
);

export default api;
